import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { StyledLink } from '../StyledComponents';
import { DetailsRow } from '../DetailsRowContentElements/DetailsRow';
import { messages } from '../../../messages';
import { ATLASSIAN_CLOUD, ATLASSIAN_ORGANISATION } from '../../../../../data/products/keys';
import { isAtlassianOrganisation } from '../../../../../util/mac/helpers';
import { checkFeatureGate, FeatureFlags } from 'util/statsig';

export const UpdateAddressDetailsLink = ({
  isAccountHosted,
  productKey,
  externalUuid,
}: {
  isAccountHosted: boolean;
  productKey: string;
  externalUuid: string;
}) => {
  const MACCloudReadModeFG = checkFeatureGate(FeatureFlags.CART_MAC_CLOUD_READ_MODE);

  const isCloudOrOrganisation =
    productKey === ATLASSIAN_CLOUD || isAtlassianOrganisation(productKey);

  if (
    (!isAccountHosted && isCloudOrOrganisation) ||
    (isCloudOrOrganisation && MACCloudReadModeFG)
  ) {
    return null;
  }

  const getHref = () => {
    if (isAccountHosted && isCloudOrOrganisation) {
      const pathSegment = productKey !== ATLASSIAN_ORGANISATION ? 's' : 'o';
      return `${config.adminHubUrl}/${pathSegment}/${externalUuid}/billing/paymentdetails`;
    }
    return 'my/edit-details';
  };

  return (
    <DetailsRow
      label={<FormattedMessage {...messages.addressDetails} />}
      value={
        <StyledLink href={getHref()}>
          <FormattedMessage {...messages.updateAddressDetails} />
        </StyledLink>
      }
      dataCy="mac-address-details"
    />
  );
};
